module.exports = __webpack_public_path__ + "img/img8.67b31e1f.png";